
import { baseApi } from "@store/apis";
import localStorageSecureWrapper from "@utilities/localStorageSecureWrapper";

import type { BadgeDetails, BadgeDetailsRequest } from "./models";

const GetBadgeDetailsQuery = baseApi.injectEndpoints({

  endpoints: builder => ({
    GetBadgeDetails: builder.query({
      query: ({ challengeId }: BadgeDetailsRequest) => ({
        url: "",
        params: {
          Endpoint: "GetBadgeDetailsById",
          ChallengeId: challengeId,
          UserId: localStorageSecureWrapper.getItem("userId"),
        },
        method: "GET",
      }),
      providesTags: ["Challenges"],
      transformResponse: (response: BadgeDetails) => response.result,
    }),
  }),
});

export const { useGetBadgeDetailsQuery } = GetBadgeDetailsQuery;
